import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createAccount: {
    method: 'POST',
    url: `${configs.baseUrl}/api/accounts/`,
  },
  getAccountById: {
    method: 'GET',
    url: `${configs.baseUrl}/api/accounts/{accountId}`,
  },
  deleteAccount: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/users/account/{memberId}`,
  },
  getTotalMembers: {
    method: 'GET',
    url: `${configs.baseUrl}/api/accounts/{accountId}/count`,
  },
  leaveTeam: {
    method: 'POST',
    url: `${configs.baseUrl}/api/accounts/leave`,
  },
  changeMemberRole: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/accounts/{accountId}/user/{userId}`,
  },
  countUserHasSameEmaildomain: {
    method: 'GET',
    url: `${configs.baseUrl}/api/accounts/{accountId}/count-user-has-same-email-domain`,
  },
  getSalesAssistedContract: {
    method: 'GET',
    url: `${configs.baseUrl}/api/accounts/sales-assisted-contract`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createAccount = async (params) => {
  const res = await resource.createAccount(params)
  return res.body
}
const getAccountById = async (accountId, params) => {
  const res = await resource.getAccountById({ accountId }, params)
  return res.body.account
}

const getTeamTotalMember = async (accountId, params) => {
  const res = await resource.getTotalMembers({ accountId }, params)
  return res.body.count
}
const deleteAccount = (memberId) => {
  return resource.deleteAccount({ memberId })
}

const leaveTeam = () => {
  return resource.leaveTeam()
}
const changeMemberRole = async (accountId, userId, params) => {
  const res = await resource.changeMemberRole({ accountId, userId }, params)
  return res.body
}
const countUserHasSameEmaildomain = async (accountId, params) => {
  const res = await resource.countUserHasSameEmaildomain({ accountId }, params)
  return res.body.count
}

const getSalesAssistedContract = async () => {
  const res = await resource.getSalesAssistedContract()
  return res.body
}

export default {
  initResource,
  createAccount,
  getAccountById,
  deleteAccount,
  getTeamTotalMember,
  leaveTeam,
  changeMemberRole,
  countUserHasSameEmaildomain,
  getSalesAssistedContract,
}
